import React from 'react';
import { LanguageAbilityTableModal } from './language-ability-table-modal.component';
import type { LanguageAbilityTableModalContainerProps } from './language-ability-table-modal.types';

export const LanguageAbilityTableModalContainer = (
  props: LanguageAbilityTableModalContainerProps,
) => {
  return <LanguageAbilityTableModal onClose={props.hideModal} />;
};
